<template>
  <v-container class="limited">
    <beneficiary-data></beneficiary-data>
    <template>
      <v-card class="elevation-5 mb-4 px-5 py-3" lg8>
        <v-layout row wrap align-center justify-start>
          <h1
            class="subheading font-weight-black primary--text mr-4"
            :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
          >
            Filtrar:
          </h1>
          <template>
            <v-layout row wrap>
              <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Data de criação"
                    prepend-icon="event"
                    readonly
                    :value="formatDataCriacao"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="pt-BR"
                  width="290px"
                  height="500px"
                  v-model="dataCriacao"
                  type="month"
                  @input="fromDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-layout>
          </template>
          <v-flex xs12 sm4 md3 class="px-2">
            <v-select
              clearable
              :items="dmTiposMovimento"
              v-model="tiposMovimento"
              item-text="descricao"
              item-value="id"
              label="Tipo"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4 md3 class="px-2">
            <v-select
              clearable
              :items="dmStatusMovimento"
              v-model="statusMovimento"
              item-text="descricao"
              item-value="id"
              label="Situação"
            ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-card>
    </template>
    <v-data-table
      :headers="headers"
      :items="findMovimentosBeneficiario.content"
      :pagination.sync="pagination"
      :total-items="findMovimentosBeneficiario.totalElements"
      :loading="isLoading"
      :rows-per-page-items="pageOptions"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      class="elevation-5"
    >
      <template v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>
          {{ props.item.atendimento ? props.item.atendimento.protocolo : "" }}
        </td>
        <td>{{ props.item.dataCriacao | formatDate }}</td>
        <td>
          {{
            props.item.tipoMovimento ? props.item.tipoMovimento.descricao : ""
          }}
        </td>
        <td>
          {{
            props.item.statusMovimento
              ? props.item.statusMovimento.descricao
              : ""
          }}
        </td>
        <td>
          <v-btn
            flat
            small
            color="green"
            @click="view(props.item)"
            v-if="
              props.item.tipoMovimento.id === 2 ||
                props.item.tipoMovimento.id === 3 ||
                props.item.tipoMovimento.id === 6
            "
            >Visualizar</v-btn
          >
        </td>
      </template>
      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";

import BeneficiaryData from "@/components/BeneficiaryData";

const { mapState } = createNamespacedHelpers("beneficiario");

import {
  getMovimentosBeneficiario,
  getStatusMovimentos,
  getTiposMovimentos
} from "@/services/movimentos";

const TIPOS_MOVIMENTO_IDS = {
  ALTERACAO: 2,
  SEGUNDA_VIA: 3,
  EXCLUSAO_BENEFICIARIO: 6
};

export default {
  name: "Movement",
  components: {
    BeneficiaryData
  },
  data() {
    const currentYear = new Date().getFullYear();
    const range = (start, stop, step) =>
      Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      );
    return {
      pageOptions: [5, 10, 25, { value: -1, text: "Todos" }],
      dialog: false,
      anos: range(currentYear, currentYear - 20, -1),
      pagination: {},
      dmTiposMovimento: [],
      dmStatusMovimento: [],
      tiposMovimento: null,
      statusMovimento: null,
      isLoading: false,
      fromDateMenu: false,
      dataCriacao: null,
      totalElements: null,
      headers: [
        { text: "Nº Movimento", value: "id" },
        { text: "Protocolo", value: "protocolo" },
        { text: "Data Criação", value: "dataCriacao" },
        { text: "Tipo", value: "tipoMovimento" },
        { text: "Situação", value: "statusMovimento" },
        { text: "", value: "view" }
      ],
      findMovimentosBeneficiario: {
        content: [],
        totalElements: 0
      },
      meses: [
        { id: 1, mes: "Janeiro" },
        { id: 2, mes: "Fevereiro" },
        { id: 3, mes: "Março" },
        { id: 4, mes: "Abril" },
        { id: 5, mes: "Maio" },
        { id: 6, mes: "Junho" },
        { id: 7, mes: "Julho" },
        { id: 8, mes: "Agosto" },
        { id: 9, mes: "Setembro" },
        { id: 10, mes: "Outubro" },
        { id: 11, mes: "Novembro" },
        { id: 12, mes: "Dezembro" }
      ]
    };
  },
  computed: {
    ...mapState(["dadosBeneficiario"]),
    formatDataCriacao() {
      return this.dataCriacao && moment(this.dataCriacao).format("MM/YYYY");
    },
    beneficiarioCartao() {
      return this.dadosBeneficiario.id;
    }
  },
  watch: {
    dataCriacao: {
      handler() {
        this.clearPagination();
        this.getMovimentosBeneficiario();
      }
    },
    tiposMovimento: {
      handler() {
        this.clearPagination();
        this.getMovimentosBeneficiario();
      }
    },
    statusMovimento: {
      handler() {
        this.clearPagination();
        this.getMovimentosBeneficiario();
      }
    },
    pagination: {
      handler() {
        this.getMovimentosBeneficiario();
      }
    },
    beneficiarioCartao: {
      handler() {
        this.clearPagination();
        this.getMovimentosBeneficiario();
      }
    }
  },
  created() {
    this.tiposMovimentos();
    this.statusMovimentos();
  },
  methods: {
    clearPagination() {
      this.pagination.page = 1;
    },
    async tiposMovimentos() {
      await getTiposMovimentos().then(response => {
        this.dmTiposMovimento = response.filter(
          tipoMovimento =>
            tipoMovimento.id === TIPOS_MOVIMENTO_IDS.ALTERACAO ||
            tipoMovimento.id === TIPOS_MOVIMENTO_IDS.SEGUNDA_VIA ||
            tipoMovimento.id === TIPOS_MOVIMENTO_IDS.EXCLUSAO_BENEFICIARIO
        );
      });
    },
    async statusMovimentos() {
      await getStatusMovimentos().then(response => {
        this.dmStatusMovimento = response;
      });
    },
    async getMovimentosBeneficiario() {
      const codigoBeneficiario = this.dadosBeneficiario.id;
      const tiposMovimento = this.tiposMovimento ? this.tiposMovimento : null;
      const statusMovimento = this.statusMovimento
        ? this.statusMovimento
        : null;
      const dataCriacaoInicio = this.dataCriacao
        ? this.dataCriacao + "-01"
        : null;
      const dataCriacaoFim = this.dataCriacao
        ? `${this.dataCriacao}-${moment(
            this.dataCriacao,
            "YYYY-MM"
          ).daysInMonth()}`
        : null;
      const page = this.pagination.page ? this.pagination.page - 1 : 0;

      const size = this.getSize();

      const order = this.pagination.descending
        ? `${this.pagination.sortBy},desc`
        : this.pagination.sortBy || "id";

      this.isLoading = true;

      await getMovimentosBeneficiario(
        codigoBeneficiario,
        tiposMovimento,
        statusMovimento,
        dataCriacaoInicio,
        dataCriacaoFim,
        page,
        size,
        order
      )
        .then(response => {
          this.findMovimentosBeneficiario = response;
          this.totalElements = response.totalElements;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getSize() {
      return this.pagination.rowsPerPage == -1
        ? this.totalElements
        : this.pagination.rowsPerPage;
    },
    view(movement) {
      if (movement.tipoMovimento.id === TIPOS_MOVIMENTO_IDS.ALTERACAO) {
        this.$router.push({
          name: "movementUpdate",
          params: { id: movement.id }
        });
      } else if (
        movement.tipoMovimento.id === TIPOS_MOVIMENTO_IDS.EXCLUSAO_BENEFICIARIO
      ) {
        this.$router.push({
          name: "movementDelete",
          params: { id: movement.id }
        });
      } else if (
        movement.tipoMovimento.id === TIPOS_MOVIMENTO_IDS.SEGUNDA_VIA
      ) {
        this.$router.push({
          name: "movementCard",
          params: { id: movement.id }
        });
      }
    }
  }
};
</script>

<style></style>
